export default {
    type: {
        INCENTIVE_SMS: { name: "SMS", value: "INCENTIVE_SMS", color: '#3f51b5' },
        INCENTIVE_PUSH: { name: "Push", value: "INCENTIVE_PUSH", color: 'teal' },
        INCENTIVE_WHATSAPP: { name: "Whatsapp", value: "INCENTIVE_WHATSAPP", color: '#535a11' },
        INCENTIVE_EMAIL: { name: "E-mail", value: "INCENTIVE_EMAIL", color: 'orange' },
    },
    step: {
        LANDING_ACCESSED: { name: "Landing acessada", value: "LANDING_ACCESSED", color: '#007327' },
        LINK_ACCESSED: { name: "Link Acessado", value: "LINK_ACCESSED", color: '#004d40' },
        LOGGED_IN: { name: "Login", value: "LOGGED_IN", color: 'goldenrod' },
        PROPOSAL_SELECTED: { name: "Proposta Selecionada", value: "PROPOSAL_SELECTED", color: '#3f51b5' },
        SYNC_RESOLVED: { name: "Propostas Sincronizadas", value: "SYNC_RESOLVED", color: 'purple' },
    }
};

